export const AVAILABLE_TECHNICIANS: string[] = [
  'a.kwiecien@juconn.com',
  'a.mijal@juconn.com',
  'a.pankow@juconn.com',
  'a.schulz@juconn.com',
  'b.schmidt@juconn.com',
  'd.vasbender@juconn.com',
  'g.kozik@juconn.com',
  'h.hintzmann@juconn.com',
  'h.ilga@juconn.com',
  'k.kosmell@juconn.com',
  'm.buechau@juconn.com',
  'm.maziarz@juconn.com',
  'm.wisser@juconn.com',
  'o.welling@juconn.com',
  'p.richter@juconn.com',
  'k.altir@juconn.com',
  'f.friederich@juconn.com',
  'w.barrie@juconn.com',
  'c.schwab@juconn.com',
  'd.baczkowski@juconn.com',
  'k.nowosielski@juconn.com',
  's.evers@juconn.com',
  'p.gogolin@juconn.com',
  'j.rommelsheim@juconn.com',
  'k.pittelkow@juconn.com',
  's.toppka@juconn.com',
  't.kuhnke@juconn.com',
  'c.wolter@juconn.com',
  'm.aminhasti@juconn.com',
  'c.kaiser@juconn.com',
  'oe.ozsoy@juconn.com',
  'd.wisniewski@juconn.com',
  'n.dudek@juconn.com',
  'm.kraus@juconn.com'
];

